import React from 'react';
import { TopBar } from '../components/TopBar';
import { Hero } from '../components/Hero';
import { Problem } from '../components/Problem';
import { Solution } from '../components/Solution';
import { Bonuses } from '../components/Bonuses';
import { Testimonials } from '../components/Testimonials';
import { Pricing } from '../components/Pricing';
import { SimpleSteps } from '../components/SimpleSteps';
import { Guarantee } from '../components/Guarantee';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { SaleNotification } from '../components/SaleNotification';
export function Landing() {
  return <div className="min-h-screen flex flex-col w-full bg-cream text-navy font-sans selection:bg-primary/30" data-id="element-250">
      <TopBar data-id="element-251" />
      <SaleNotification data-id="element-252" />
      <main className="flex-1 flex flex-col w-full" data-id="element-253">
        <Hero data-id="element-254" />
        <Problem data-id="element-255" />
        <Solution data-id="element-256" />
        <Bonuses data-id="element-257" />
        <Testimonials data-id="element-258" />
        <Pricing data-id="element-259" />
        <SimpleSteps data-id="element-260" />
        <Guarantee data-id="element-261" />
        <FAQ data-id="element-262" />
        <FinalCTA data-id="element-263" />
      </main>
      <Footer data-id="element-264" />
    </div>;
}